import React from "react";
import { JsonLd } from "../components/common/JsonLd";
import { RelatedPages } from "../components/common/RelatedPages";
import { SEOHelmet } from "../components/common/SEOHelmet";
import { PATH_GROUP_THERAPY } from "../utils/constants";
import groupsData from "../data/groups.json";
import { Group } from "../types/group";
import { GroupCard } from "../components/common/GroupCard";
import { buildGroupTherapyPageGraph } from "../utils/structured-data";

export default function GroupTherapyPage() {
  const groups = (groupsData as { groups: Group[] }).groups;

  return (
    <>
      <SEOHelmet page="gruppentherapie" pathname={PATH_GROUP_THERAPY} />
      <JsonLd data={buildGroupTherapyPageGraph(groups)} />

      <main>
      <section aria-labelledby="groups-heading">
        <header className="mb-6 sm:mb-8">
          <h1
            id="groups-heading"
            className="text-3xl sm:text-4xl font-semibold tracking-tight text-gray-900 dark:text-white"
          >
            Gruppentherapien
          </h1>
          <p className="mt-4 text-base text-gray-500 dark:text-gray-400 max-w-3xl">
            Entdecken Sie unsere aktuellen Gruppentherapie-Angebote. Klicken Sie eine Gruppe an um die PDF
            herunterzuladen.
          </p>
        </header>

        {groups.length === 0 ? (
          <p className="text-gray-500 dark:text-gray-400">Aktuell sind keine Gruppen eingetragen.</p>
        ) : (
          <div className="grid gap-6 sm:gap-8 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
            {groups.map((g) => (
              <GroupCard key={g.id} group={g} />
            ))}
          </div>
        )}
        <RelatedPages pathname={PATH_GROUP_THERAPY} />
      </section>
      </main>
    </>
  );
}
